import React, { useEffect, useState } from "react";
import { Button, Form, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import * as Yup from "yup";
import { useFormik } from "formik";
import { useQueryClient } from "react-query";
import toast from "react-hot-toast";
import { Spin } from "antd";
import { CarOutlined } from "@ant-design/icons";
import { createInstruction, updateInstruction } from "../service/instructionApi";
import { useTranslation } from 'react-i18next'; // Assure-toi d'importer ce hook

const AddEditInstructonForm = ({ modal, setModal, toggle, selectedInstruction }) => {
    const { t } = useTranslation();  // Utilise useTranslation pour récupérer les traductions
  
    const queryClient = useQueryClient();
    const [isLoadingSubmit, setisLoadingSubmit] = useState(false);

    const validationSchema = Yup.object().shape({
        name: Yup.string().required(t("instruction.name") + " is required"),
        description: Yup.string().required(t("instruction.description") + " is required")
    });

    const initialValues = selectedInstruction ? {
        name: selectedInstruction.name,
        description: selectedInstruction.description,
    } : {
        name: "",
        description: "",
    };

    const formik = useFormik({
        initialValues: initialValues,
        validationSchema: validationSchema,
        onSubmit: async (values) => {
            setisLoadingSubmit(true);
            try {
                const payload = {
                    name: values.name, 
                    description: values.description,
                };
                
                if (selectedInstruction) {
                    await updateInstruction(selectedInstruction?.id, payload);
                    toast.success(t("instruction.success_edit"));
                } else {
                    await createInstruction(payload);
                    toast.success(t("instruction.success_add"));
                }
                
                await queryClient.invalidateQueries("instructions");
                toggle();
                formik.resetForm();
            } catch (error) {
                if (selectedInstruction) {
                    console.error("Erreur modification instruction :", error?.message || error);
                    toast.error(t("instruction.error"));
                } else {
                    console.error("Erreur lors de l'ajout de l'instruction :", error?.message || error);
                    toast.error(t("instruction.error"));
                }
            }
            finally {
                setisLoadingSubmit(false);
            }
        },
    });

    useEffect(() => {
        formik.setValues(initialValues);
    }, [selectedInstruction]);

    const modalTitle = selectedInstruction ? t("instruction.edit") : t("instruction.add");

    return (
        <Modal
            id="showModalClient"
            isOpen={modal}
            toggle={toggle}
            centered
            backdrop={"static"}
        >
            <ModalHeader className="bg-info-subtle p-3" toggle={toggle}>
                {modalTitle} <CarOutlined />
            </ModalHeader>
            <Form onSubmit={formik.handleSubmit}>
                <ModalBody>
                    <div className="mb-3">
                        <label htmlFor="name" className="form-label">{t("instruction.name")}</label>
                        <input
                            type="text"
                            id="name"
                            name="name"
                            className="form-control"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.name}
                            style={{
                                borderRadius: '20px',
                            }}
                            required="true"
                        />
                        {formik.touched.name && formik.errors.name ? (
                            <div className="text-danger">{formik.errors.name}</div>
                        ) : null}
                    </div>
                    <div className="mb-3">
                        <label htmlFor="description" className="form-label">{t("instruction.description")}</label>
                        <textarea
                            id="description"
                            name="description"
                            className="form-control"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.description}
                            rows="4"
                            style={{
                                borderRadius: '20px',
                            }}
                            required
                        />
                        {formik.touched.description && formik.errors.description ? (
                            <div className="text-danger">{formik.errors.description}</div>
                        ) : null}
                    </div>
                </ModalBody>
                <ModalFooter>
                    <Button color="light" className="bordered-btn-light btn-spacing" onClick={() => setModal(false)}>
                        {t("instruction.cancel")}
                    </Button>
                    <Button type="submit" className="bordered-btn" disabled={isLoadingSubmit}>
                        {isLoadingSubmit ? <Spin size="small" text="En cours" /> : (selectedInstruction ? t("instruction.edit") : t("instruction.submit"))}
                    </Button>
                </ModalFooter>
            </Form> 
        </Modal>
    );
};

export default AddEditInstructonForm;
